import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";

const AdminInvoice = () => {
  const [order, setOrder] = useState(null); // Initialize as null for clearer loading state
  const [salesOrderData, setSalesOrderData] = useState(null);
  const [profileData, setProfileData] = useState({});
  const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY;

  const encryptedToken = Cookies.get("token");
  const token = encryptedToken
    ? CryptoJS.AES.decrypt(encryptedToken, encryptionKey).toString(
        CryptoJS.enc.Utf8
      )
    : null;

  // Fetch business profile data
  const getprofile = async () => {
    try {
      let res = await axios.get(
        "https://parnetslink.xyz/api/admin/getbussinessprofile"
      );
      if (res.status === 200) {
        setProfileData(res.data.profile || {});
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  // Fetch sales order data
  const fetchSalesOrder = async (orderId) => {
    try {
      const response = await axios.get(
        `https://parnetslink.xyz/api/user/getSalesOrder/${orderId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        setSalesOrderData(response.data.data);
      } else {
        console.error("Sales order not found");
      }
    } catch (error) {
      console.error("Error fetching sales order:", error);
    }
  };

  useEffect(() => {
    const storedOrder = JSON.parse(localStorage.getItem("InvoiceItem"));
    console.log("storedOrder",storedOrder)
    if (storedOrder) {
      setOrder(storedOrder?.originalData);
      fetchSalesOrder(storedOrder?.originalData?._id);
    }
    getprofile();
  }, []);

  const handlePrint = () => {
    window.print();
  };

  if (!order) {
    return <p className="text-center text-gray-500">Loading invoice...</p>;
  }

  return (
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-section, .print-section * {
              visibility: visible;
            }
            .print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              box-shadow: none;
              padding: 20px;
              font-size: 12pt;
            }
            .no-print {
              display: none;
            }
            .print-section .item-table {
              width: 100%;
              border-collapse: collapse;
            }
            .print-section .item-table th,
            .print-section .item-table td {
              border: 1px solid #000;
              padding: 8px;
              text-align: right;
            }
            .print-section .item-table th:first-child,
            .print-section .item-table td:first-child {
              text-align: left;
            }
            .print-section .bg-gray-200 {
              background-color: #f0f0f0 !important;
            }
          }
        `}
      </style>
      <div className="print-section">
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Abhinandhan Enterprise</h1>
          <p className="text-sm text-gray-600">
            {profileData?.address || "123 Store Street, City, State - 123456"}
          </p>
          <p className="text-sm text-gray-600">
            Phone: {profileData?.phoneNumber ? `+91 ${profileData.phoneNumber}` : "(123) 456-7890"}
          </p>
          {profileData?.email && (
            <p className="text-sm text-gray-600">Email: {profileData.email}</p>
          )}
          {profileData?.gstNumber && (
            <p className="text-sm text-gray-600">GST: {profileData.gstNumber}</p>
          )}
        </div>
        <div className="flex justify-between text-sm mb-6">
          <div>
            <p className="text-gray-700">
              <strong>Invoice No:</strong> {order._id || "N/A"}
            </p>
            <p className="text-gray-700">
              <strong>Date:</strong>{" "}
              {order.orderDate
                ? new Date(order.orderDate).toLocaleDateString()
                : "N/A"}
            </p>
            <p className="text-gray-700">
              <strong>Time:</strong>{" "}
              {order.orderDate
                ? new Date(order.orderDate).toLocaleTimeString()
                : "N/A"}
            </p>
          </div>
          <div className="text-right">
            <p className="text-gray-700">
              <strong>Customer:</strong>{" "}
              {order.shippingAddress?.fullName ||
                order.shippingAddress?.name ||
                "N/A"}
            </p>
            <p className="text-gray-700">
              <strong>Phone:</strong>{" "}
              {order.shippingAddress?.mobile ||
                order.shippingAddress?.number ||
                "N/A"}
            </p>
            <p className="text-gray-700">
              <strong>Address:</strong>{" "}
              {order.shippingAddress
                ? `${order.shippingAddress.street || order.shippingAddress.address1 || ""}, ${
                    order.shippingAddress.city || order.shippingAddress.address2 || ""
                  }${order.shippingAddress.state ? `, ${order.shippingAddress.state}` : ""} ${
                    order.shippingAddress.pincode || ""
                  }`
                : "N/A"}
            </p>
          </div>
        </div>
        <div className="mb-6">
          <div className="flex justify-between text-sm font-bold bg-gray-200 p-3 rounded-t">
            <span className="w-1/2">Item</span>
            <span className="w-1/6 text-right">Qty</span>
            <span className="w-1/6 text-right">Price</span>
            <span className="w-1/6 text-right">Total</span>
          </div>
          {Array.isArray(order.items) && order.items.length > 0 ? (
            order.items.map((item, index) => (
              <div
                key={index}
                className="flex justify-between text-sm border-b py-3 text-gray-700"
              >
                <span className="w-1/2">{item.name || "Unknown Item"}</span>
                <span className="w-1/6 text-right">{item.quantity || 0}</span>
                <span className="w-1/6 text-right">
                  ₹{(item.price || 0).toFixed(2)}
                </span>
                <span className="w-1/6 text-right">
                  ₹{((item.quantity || 0) * (item.price || 0)).toFixed(2)}
                </span>
              </div>
            ))
          ) : (
            <div className="text-sm text-gray-700 py-3 text-center">
              No items available
            </div>
          )}
        </div>
        {salesOrderData && (
          <div className="mb-6">
            <h4 className="font-bold text-lg text-gray-800">Sales Order Items</h4>
            <div className="flex justify-between text-sm font-bold bg-gray-200 p-3 rounded-t">
              <span className="w-1/2">Item</span>
              <span className="w-1/6 text-right">Qty</span>
              <span className="w-1/6 text-right">Price</span>
              <span className="w-1/6 text-right">Total</span>
            </div>
            {Array.isArray(salesOrderData.items) && salesOrderData.items.length > 0 ? (
              salesOrderData.items.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between text-sm border-b py-3 text-gray-700"
                >
                  <span className="w-1/2">{item.name || "Unknown Item"}</span>
                  <span className="w-1/6 text-right">{item.quantity || 0}</span>
                  <span className="w-1/6 text-right">
                    ₹{(item.price || 0).toFixed(2)}
                  </span>
                  <span className="w-1/6 text-right">
                    ₹{((item.quantity || 0) * (item.price || 0)).toFixed(2)}
                  </span>
                </div>
              ))
            ) : (
              <div className="text-sm text-gray-700 py-3 text-center">
                No sales order items available
              </div>
            )}
          </div>
        )}
        <div className="text-right mb-6">
          {!salesOrderData && (
            <p className="text-gray-700">
              <strong>Total MRP:</strong> ₹{((order?.totalAmount || 0) + (order?.discount || 0) - (order?.deliveryCharge || 0)).toFixed(2)}
            </p>
          )}
          {!salesOrderData && (
            <p className="text-gray-700">
              <strong>Shipping Fees:</strong> ₹{(order?.deliveryCharge || 0).toFixed(2)}
            </p>
          )}
          {!salesOrderData && (
            <p className="text-green-600">
              <strong>Discount:</strong> ₹{(order?.discount || 0).toFixed(2)}
            </p>
          )}
          {salesOrderData && (
            <p className="text-gray-700">
              <strong>Total Sales Amount:</strong> ₹{(salesOrderData.totalAmount || 0).toFixed(2)}
            </p>
          )}
          {!salesOrderData && (
            <p className="text-lg font-bold text-gray-800">
              Total: ₹{(order.totalAmount || 0).toFixed(2)}
            </p>
          )}
        </div>
        <div className="text-center text-sm mb-6 text-gray-600">
          <p>Thank you for shopping with us!</p>
          <p>Please keep this invoice for any returns or exchanges.</p>
        </div>
      </div>
      <div className="flex justify-center no-print">
        <button
          onClick={handlePrint}
          className="px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
        >
          Print Invoice
        </button>
      </div>
    </div>
  );
};

export default AdminInvoice;